export const base64UrlEncode = (challenge) => {
    return Buffer.from(challenge)
        .toString("base64")
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
};
//# sourceMappingURL=base64UrlEncode.js.map